var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cc-error",class:{ 'cc-error--has-error': _setup.hasErrors }},[_vm._t("default"),(_setup.hasErrors)?_c(_setup.CcAlert,{attrs:{"icon":"errorCircle","type":"error","text":_setup.errors?.[0].message}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }